<template>
  <section class="hero app-navbar">
    <div class="hero-head">
      <nav class="navbar">
        <div class="navbar-brand">
          <div v-bind:class="{ 'navbar-burger': true, 'burger': true, 'is-active': !showBurger }" v-on:click="$emit('toggleSidebar')">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="navbar-item is-size-5 has-text-weight-light">{{ this.$store.state.organization.name }}</div>
        </div>
        <div class="navbar-menu">
          <div class="navbar-end">
            <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link">
                  <p><span class="icon"><i class="fa fa-lg fa-user-circle-o"></i></span> {{ this.$store.state.customer.name }}</p>
              </a>
              <div class="navbar-dropdown is-right">
                <div v-for="organization in this.$store.state.organizations">
                  <a
                    v-on:click="switchOrganization(organization.id)"
                    v-bind:class="{ 'navbar-item': true, 'is-active': organizationIsActive(organization.id) }">
                    <div class="field">
                      <p>{{ organization.name }}</p>
                      <p class="has-text-grey-light">id: {{ organization.id }} | slug: {{ organization.slug }}</p>
                    </div>
                  </a>
                </div>
                <hr class="navbar-divider">
                <a class="navbar-item" v-on:click="logout">
                  <span class="icon"><i class="fa fa-lg fa-sign-out"></i></span>
                  <span>Log out</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </section>
</template>

<script>
  export default {
    props: [ 'showBurger' ],

    methods: {
      organizationIsActive (organizationId) {
        return organizationId === parseInt(this.$store.state.organizationId)
      },

      setOrganization (organizationId) {
        // Find the organization by id
        const organization = this.$store.state.organizations.find(organization => organization.id === parseInt(organizationId))

        // Set current organization in the store
        this.$store.commit('SET_ORGANIZATION', organization)

        // Set current organization in the Local Storage
        window.localStorage.setItem(`${process.env.LOCALSTORAGE_PREFIX}organization_id`, organizationId)
      },

      switchOrganization (organizationId) {
        this.setOrganization(organizationId)

        this.$router.push('/')
      },

      logout: function (event) {
        if (event) event.preventDefault()

        this.$store.commit('LOGOUT')
        this.$store.commit('SET_AUTHENTICATED', false)

        window.localStorage.clear()
      }
    },

    created () {
      // Get customer with organizations
      this.$store.dispatch('getCustomer', {
        customerId: this.$store.state.customerId,
        params: {
          include: 'organizations'
        }
      })
        .then(() => {
          if (this.$store.state.organizationId) {
            return this.setOrganization(this.$store.state.organizationId)
          }

          return this.setOrganization(this.$store.state.organizations[0].id)
        })
    }
  }
</script>

<style lang="scss">
  @import '~bulma/sass/utilities/variables';

  .app-navbar {
    background-color: rgba(255, 255, 255, 1);
    position: fixed;
    min-width: 100%;
    box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);
    z-index: 1024;

    .navbar-burger {
      margin-left: inherit;
    }

    .container {
      margin-right: 50px;
    }

    // .nav-right {
    //   align-items: stretch;
    //   align-items: stretch;
    //   flex: 1;
    //   justify-content: flex-end;
    //   overflow: hidden;
    //   overflow-x: auto;
    //   white-space: nowrap;
    // }
  }
</style>



// WEBPACK FOOTER //
// Navbar.vue?d26809fc